module.exports = __webpack_public_path__ + "img/avatar4.2af1af8d.png";